import React, {Component} from "react";
import {withTranslate} from "react-redux-multilingual";
import axios from "axios";
import {registerUrl} from "./../../config";
import {Link, Redirect} from "react-router-dom";
import {changeAuthPopUpStatus} from "../../store/actions/reservationActions";
import {profile, authTogglePopUpStatus, setUserUniqueId, succeedAuth} from "../../store/actions/userActions";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {showToast} from "../../helpers/magic";

class Register extends Component {

    state = {
        name: "",
        password: "",
        email: "",
        mobile: "",
        isError: false,
        success: false,
        isActive: false,
        errors: [],
        loading: false,
        fromOtherLink: false,
    };

    /*componentDidMount() {
        const access_token = JSON.parse(window.localStorage.getItem("access_token"));

        if (access_token) {
            this.props.history.push("/")
        }

    }*/
    componentDidMount() {
        this.setState({
            fromOtherLink: false
        })
        if (this.props.match.params && this.props.match.params.id) {
            this.props.setUserUniqueId(this.props.match.params.id);
        } else {
            this.props.setUserUniqueId(-1);
        }
        if (this.props.match.path.includes("user")) {
            this.props.history.push({pathname: "/register"})
        }
        if (this.props.match.path.includes("doctor") || this.props.match.path.includes("premium")) {
            this.setState({
                fromOtherLink: true
            })
        }
    }

    handleInputChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    };
    handleSignUp = (e) => {
        e.preventDefault();
        // start loading
        this.setState({
            loading: true,
        });

        // prevent default behavior

        const form = document.getElementById("register-form");

        const errorDesc = document.getElementById("error-desc");

        let data = {};
        data = this.state;
        data.shareUserUniqueId = this.props.userUniqueId;

        axios.post(registerUrl, data).then(res => {
            // stop loading
            this.setState({
                loading: false,
            });

            if (res.data.Error.code === 21 || res.data.Error.code === 27) {
                // cache user & access token
                localStorage.setItem("isActive", JSON.stringify(res.data.Response.is_active));
                localStorage.setItem("code", JSON.stringify(res.data.Response.pin));
                localStorage.setItem("access_token", JSON.stringify(res.data.Error.token));

                this.resetErrors();
                form.reset();

                if (this.props.match.path.includes("doctor") || this.props.match.path.includes("premium")) {
                    this.props.changeAuthPopUpStatus(false);
                    this.props.profile();
                    if (this.props.match.path.includes("premium")) {
                        this.props.succeedAuth();
                    }
                    showToast(this.props.translate('you_logged_in_successfully'), "green")
                }

                this.setState({
                    name: "",
                    password: "",
                    email: "",
                    mobile: "",
                    isActive: true,
                    success: true,
                });

            } else {
                switch (res.data.Error.code) {
                    /*       case 27:
                               localStorage.setItem("isActive", JSON.stringify(res.data.Response.is_active));
                               localStorage.setItem("access_token", JSON.stringify(res.data.Error.token));
                               this.setState({
                                   isActive: true
                               });
                               break;*/
                    case 24:
                        this.handleRecordErrors(res.data.Error.validation);
                        break;
                    case 500:
                        errorDesc.innerHTML = res.data.Error.desc;
                        this.setState({
                            isError: true
                        });
                        break;

                    default:
                        break;
                }
            }
        }).catch(error => {
            console.log(error);
            this.setState({
                loading: true,
            });
        });
    };
    clearValidationError = (e) => {
        let errors = this.state.errors;
        errors[e.target.id] = null;
        this.setState({
            errors: errors
        })
    };

    // handle form errors
    handleErrors(field) {
        if (this.state.errors) {
            return this.state.errors[field]
        }
        return false
    }

    // record errors
    handleRecordErrors = (errors) => {
        this.setState({
            errors: errors
        });
    };
    // reset errors
    resetErrors = () => {
        this.setState({
            errors: []
        })
    };

    handleLoginBtn = () => {
        this.props.match.path.includes("doctor") || this.props.match.path.includes("premium") ? this.props.authTogglePopUpStatus(false) : this.props.history.push('login');
    };

    render() {

        if (this.state.success === true) {
            if (!this.props.match.path.includes("doctor") && !this.props.match.path.includes("premium")) {
                return <Redirect to='/'/>
            }
        }
        /*if (this.state.success === true && this.state.isActive === false) {
            return <Redirect to='/'/>
        }*/

        /* let isActive = localStorage.getItem("isActive") ? JSON.parse(localStorage.getItem("isActive")) : null;
         let token = localStorage.getItem("access_token") ? JSON.parse(localStorage.getItem("access_token")) : null;
 */

        return (
            <div className="register" id="register">
                {/*{
                    (token) && (isActive === 0) ?
                        <Activate/> :*/}
                <div>
                    <div className="register-form relative wrap-login100 p-l-50 p-r-50 p-t-50 p-b-25">
                        <a href="/" className="closebtn" hidden={!this.state.fromOtherLink}
                           onClick={(e) => this.props.changeAuthFormStatus(e, "close")}>&times;</a>
                        <form className="login100-form validate-form" onSubmit={this.handleSignUp}
                              id="register-form">
                            <a href="/" className="logo-auth" hidden={this.state.fromOtherLink}> <img
                                src="images/logo.png" alt="seena logo"/>
                            </a>
                            <span className="login100-form-title p-b-59">
                            {this.props.translate('register')}
                        </span>
                            <div className="wrap-input100 validate-input">
                                <input id="name" type="text" onChange={this.handleInputChange}
                                       onFocus={(e) => this.clearValidationError(e)}
                                       className="form-control input100 curvy-input"
                                       placeholder="Name"/>
                                <span
                                    className="error-msg">{this.handleErrors("name")}</span>
                            </div>
                            <div className="wrap-input100 validate-input">
                                <input id="email" type="text" onChange={this.handleInputChange}
                                       onFocus={(e) => this.clearValidationError(e)}
                                       className="form-control input100 curvy-input"
                                       placeholder="Email"/>
                                <span
                                    className="error-msg">{this.handleErrors("email")}</span>
                            </div>
                            <div className="wrap-input100 validate-input">
                                <input id="password" onChange={this.handleInputChange} type="password"
                                       onFocus={(e) => this.clearValidationError(e)}
                                       className="form-control input100 curvy-input"
                                       autoComplete="new-password"
                                       placeholder="password"/>

                                <span
                                    className="error-msg">{this.handleErrors("password")}</span>
                            </div>
                            <div className="wrap-input100 validate-input relative">
                                <input id="mobile" type="text" onChange={this.handleInputChange}
                                       pattern="\d{11}"
                                       onFocus={(e) => this.clearValidationError(e)}
                                       className="form-control input100 curvy-input"
                                       placeholder="Mobile"
                                       title={this.props.translate('mobileValidationMsg')}/>
                                <span
                                    className="error-msg">{this.handleErrors("mobile")}</span>
                            </div>
                            <div className="container-login100-form-btn relative">
                                <button type="submit"
                                        className="login100-form-btn btn-block cursor-pointer curvy-input height-45">{this.props.translate("sign_up")}</button>

                                <span id="loading" className="auth-loading"
                                      hidden={this.state.loading === false}>
                                                    <img style={{width: "30px", height: "30px", marginTop: "15px"}}
                                                         src="/images/loading-white.svg" alt="loading"/>
                                                </span>
                            </div>
                            <div className="text-center link-area full-width">
                                <div onClick={() => this.handleLoginBtn()}
                                     className="decoration-none cursor-pointer">
                                    {this.props.translate("have_account_ques")}
                                </div>
                                <div hidden={this.state.fromOtherLink}>
                                    <Link to="/"><span>{"<- " + this.props.translate("back_to_home")} </span></Link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        // for show/hide pop up
        authPopUpStatus: state.reservation.authPopUpStatus,
        //for show login or register
        authToggleFormStatus: state.user.authToggleFormStatus,
        userUniqueId: state.user.userUniqueId,
    }
};


const mapDispatchToProps = (dispatch) => {
    return {
        // for show/hide pop up
        changeAuthPopUpStatus: (status) => dispatch(changeAuthPopUpStatus(status)),
        //for show login or register
        authTogglePopUpStatus: (status) => dispatch(authTogglePopUpStatus(status)),
        // to make sure that user logged on or register successfully
        succeedAuth: () => dispatch(succeedAuth()),
        profile: () => {
            dispatch(profile())
        },
        setUserUniqueId: (unique_id) => {
            dispatch(setUserUniqueId(unique_id))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(withRouter(Register)))
